import React from 'react'
import { Button, Loading, Modal, ModalProps } from '@therms/atalaya'
import {
  ReportContextProvider,
  UserClientViewingReport,
  useReport,
} from '@therms/react-modules'
import { ReportHeaderSection } from '@src/modules/Reports/shared/ReportHeaderSection'
import { ReportDetailsSection } from '@src/modules/Reports/shared/ReportDetailsSection'
import { ReportInfo } from '@src/modules/Reports/shared/ReportInfo'

interface ViewReportModalProps extends Omit<ModalProps, 'children' | 'header'> {
  reportId: string
}

function ViewReportModal({ reportId, ...modalProps }: ViewReportModalProps) {
  const { data, loading, refresh } = useReport({
    reportId,
  })

  if (!data && loading) return <Loading overlay size="xxl" />

  if (!data)
    return (
      <div className="flex w-full items-center justify-center space-x-xs text-color-critical">
        <span>There was a problem loading</span>
        <Button onClick={refresh}>Refresh</Button>
      </div>
    )

  const { report, reportType } = data
  return (
    <Modal
      {...modalProps}
      escPressClose={modalProps.outsideClickClose ?? true}
      header={<ReportHeaderSection loading={loading} report={report} />}
      outsideClickClose={modalProps.outsideClickClose ?? true}
      width="xl"
    >
      <ReportContextProvider reportId={reportId}>
        <UserClientViewingReport reportId={reportId} />

        <div className="relative">
          <ReportDetailsSection report={report} />

          <div className="mt-base border-t border-border" />

          <ReportInfo report={report} reportType={reportType} />
        </div>
      </ReportContextProvider>
    </Modal>
  )
}

export { ViewReportModal }
